import { createConsts, createActions } from '../../utils/redux';

export const consts = createConsts(
  'ui',
  'contextbar',
  'TOGGLE_VISIBILITY',
  'RESET',
);
export const actions = createActions(consts);

const initialState = {
  visible: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case consts.TOGGLE_VISIBILITY:
      return {
        ...state,
        visible: !state.visible,
      };
    case consts.RESET:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/contextbar.js